import React from 'react';
import { useTable, useFilters } from 'react-table';


const StockMetricTable = ({columns, data}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setFilter } = useTable({
    columns,
    data,
  }, useFilters);

  return (
      <table {...getTableProps()} style={{ borderSpacing: '0', width: '100%' }}>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map(column => (
                <th {...column.getHeaderProps()} style={{ borderBottom: '2px solid black', background: 'aliceblue', padding: '8px', textAlign: 'left' }}>
                  {column.render('Header')}
                  <div>
                    {column.canFilter ? (
                        <input value={column.filterValue || ''}
                        onChange={e => setFilter(column.id, e.target.value)} />
                    ) : null}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map(cell => (
                  <td {...cell.getCellProps()} style={{ padding: '8px', borderBottom: '1px solid black' }}>
                    {cell.render('Cell')}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
 };

export default StockMetricTable;
